import html2pdf from "html2pdf.js";

export const createPDFPage = async (token: string, qrCodeDataUrl: string) => {
  const page = document.createElement("div");
  page.className = "pdf-page";
  page.style.padding = "40px";
  page.style.textAlign = "center";
  page.style.pageBreakAfter = "always";

  const qrImage = document.createElement("img");
  qrImage.src = qrCodeDataUrl;
  qrImage.style.width = "300px";
  qrImage.style.height = "300px";
  qrImage.style.marginBottom = "20px";
  qrImage.style.display = "block";
  qrImage.style.margin = "0 auto 20px auto";

  const tokenText = document.createElement("p");
  tokenText.textContent = `Personlig Kod: ${token}`;
  tokenText.style.fontSize = "24px";
  tokenText.style.fontFamily = "monospace";
  tokenText.style.marginTop = "20px";

  const nameContainer = document.createElement("div");
  nameContainer.style.marginTop = "20px";
  nameContainer.style.fontSize = "24px";
  nameContainer.style.fontFamily = "monospace";
  
  const nameLabel = document.createElement("span");
  nameLabel.textContent = "Namn: ";
  
  const nameLine = document.createElement("span");
  nameLine.textContent = "_____________________";
  
  nameContainer.appendChild(nameLabel);
  nameContainer.appendChild(nameLine);

  page.appendChild(qrImage);
  page.appendChild(tokenText);
  page.appendChild(nameContainer);

  return page;
};

export const generatePDF = async (container: HTMLDivElement) => {
  await html2pdf()
    .set({
      margin: 0,
      filename: 'survey-qr-codes.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    })
    .from(container)
    .save();
};